// extracted by mini-css-extract-plugin
export default {"faq_hide":"Collapse_faq_hide__EkMTg","faq_show":"Collapse_faq_show__vDG2P"};